export const css = {
    root: 'egzJWd2u',
    extended: '_1EnozsjK',
    small: '_1iQHRu78',
    label: '_1UzWn1lq _18Q0dUhR',
    disabled: '_2T4gGtBW',
    bottomRight: '_2YqJWchX',
    bottomCenter: '_19gz5u7I',
    bottomLeft: '_3fvJ396-',
    rightCenter: '_24Xc2e3X',
    leftCenter: '_SrZr58S',
    topLeft: '_2Qguxhzt',
    topCenter: '_3Z2r2-F_',
    topRight: '_34CdNLt-',
    ' _key': 'certwise-theme/dojo/floating-action-button'
};
export default css;
